<article>
	<header>
		<cache-date></cache-date>
		
		<h3>
			{{ 'adminstat.site_action.title' | translate }}
		</h3>
	</header>
	
	<section>
		<period></period>
	</section>
	
	<section>
		<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>
		<hr/>
	</section>
	
	<section>
		<form [formGroup]="form">
			<div class="form-group">
				<label>Длина интервала</label>
				<input type="number" class="form-control" formControlName="value">
			</div>
			
			<div class="form-group">
				<label>Тип интервала</label>
				
				<select class="form-control" formControlName="type">
					<option value="hour">hour</option>
					<option value="day">day</option>
				</select>
			</div>
			
			<div class="form-group">
				<label>Граница в конверсии по кол-ву действий</label>
				<input type="number" class="form-control" formControlName="border">
			</div>
			
		</form>
	</section>
	
	<section>
		<div class="alert alert-success" role="alert">
			Считаем конверсия в платников и конверсия в платников по кол-ву действий, где:
			
			<br/>
			
			кол-во пользователей с кол-вом действий больше {{ filter.filterParams.relativeInverval.border }} / кол-во пользователей.
			
			<br/>
			
			Учитываем только действия, попадающие в интервал [даты регистрации,  даты регистрации + интервал).
		</div>
	
	</section>
	
	<section>
		<chart [data]="conversionChart.data" [options]="conversionChart.options"></chart>
		
		<hr/>
	</section>
	
	<section>
		<div class="alert alert-success" role="alert">
			Считаем среднее кол-во действий для двух метрик (по сайтово):
			<ul>
				<li>
					платник. Сайт был оплачен хоть раз;
				</li>
				
				<li>
					неплатник. Сайт ни разу не был платником.
				</li>
			</ul>
			
			Учитываем только действия, попадающие в интервал [даты регистрации,  даты регистрации + интервал).
		</div>
		
	</section>
	
	<section>
		<chart [data]="actionChart.data" [options]="actionChart.options"></chart>
		
		<hr/>
	</section>
</article>
